<section class="w3l-form-25">
  <div class="w3l-form-25">
    <BR>
   <label style="width: 250px;">   </label>
   <button type="button" id="Arabic" name="Arabic"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchArabic()">ع </button>
   <button type="button" id="English" name="English"  style="font-size: large;font-style: initial;font-family: Arial, Helvetica, sans-serif;width: 70px;" (click)="switchEnglish()">En</button>
 </div>
 <div class="form-inner-cont">
  <div class="w3l-form-25">
      <h1>{{'Accounting Department Data' | translate }}</h1>
      <p>{{'Enter Contacts Information' | translate }}</p>
      <h1 style="color: rgb(79, 79, 161);font-weight: bolder;">{{ 'Contacts Information' | translate }}</h1>
  </div>
</div>

<div id="w3l-appointment">
  <div class="wrapper">
  <div class="d-grid doctor-appointment">
    <form action="#" method="post" >

        <div class="appointment-form-field">
            <label style="width: 100px;">{{ 'Code' | translate }}</label>
            <span class="fa fa-search" aria-hidden="true" style="cursor: grab;" (click)="openDialog()"></span>
            <a href="ContactSearchAdv" class="drop-text">
              <span class="fa fa-search-plus" aria-hidden="true" style="cursor: grab;" (click)="openDialog()"></span>
            </a>
              <input type="text" name="clsscSerial"  style="width: 152px;" [(ngModel)]="concode" (change)="RetriveContacts()">
          </div>
        <div class="appointment-form-field">
          <label style="width: 100px;">{{ 'Name' | translate }}</label>
          <select id="kind" name="trkind" style="width: 250px;background-color:  rgb(187, 203, 238);" [(ngModel)]= "consaklut" [value]="consaklut"  required>
            <option value=""></option>
            <option value="السيـــد">السيـــد</option>
            <option value="السيــدة">السيــدة</option>
            <option value="الأستـاذ">الأستـاذ</option>
            <option value="الأستاذه">الأستاذه</option>
            <option value="الدكتــور">الدكتــور</option>
            <option value="الدكتورة">الدكتورة</option>
            <option value="الأنـــسة">الأنـــسة</option>
            <option value="الحــــاج">الحــــاج</option>
            <option value="الحـاجـه">الحـاجـه</option>
            <option value="السفيــر">السفيــر</option>
            <option value="المهنـدس">المهنـدس</option>
            <option value="المهندسة">المهندسة</option>
        </select>
          <input type="text" name="classname" style="width: 500px;" [(ngModel)]="conaname" >
        </div>
        <div class="appointment-form-field">
          <label style="width: 100px;">{{ 'Job' | translate }}</label>
          <select  name="jobe" style="width: 250px;background-color:  rgb(187, 203, 238);" [(ngModel)]= "conclass" [value]="conclass"  required>
            <option  value="{{cls.clasCCode}}" *ngFor="let cls of SpcialList; let i = index">{{cls.clasCName}}</option>
        </select>
        <label style="width: 150px;"></label>
        <label style="width: 100px;">{{ 'Spcialist' | translate }}</label>
        <select  name="classfication" style="width: 250px;background-color:  rgb(187, 203, 238);" [(ngModel)]= "conspecial" [value]="conspecial"  required>
          <option  value="{{cls.catCode}}" *ngFor="let cls of CategoryList; let i = index">{{cls.catName}}</option>
        </select>
      </div>
      <div class="appointment-form-field">
        <label style="width: 100px;">{{ 'Contact Person' | translate }}</label>
        <input type="text" name="contactPerson"  style="width: 750px;" [(ngModel)]="conkeytitel" >
      </div>
      <div class="appointment-form-field">
        <label style="width: 100px;">{{ 'Contact Person Title' | translate }}</label>
        <input type="text" name="contactPersontitle"  style="width: 750px;" [(ngModel)]="conkeyperson" >
      </div>
      <div class="appointment-form-field">
        <label style="width: 100px;">{{ 'Governorate' | translate }}</label>
        <select id="Governorate_1" style="width: 750px;" [(ngModel)]="conarea" required >
          <option value="{{x.govename}}" *ngFor="let x of MasterListGov; let i = index">{{x.govename}}</option>
        </select>
      </div>
      <div class="appointment-form-field">
        <label style="width: 100px;">{{ 'Address 1' | translate }}</label>
        <input type="text" name="contactadd1"  style="width: 750px;" [(ngModel)]="conaddress1" >
      </div>
      <div class="appointment-form-field">
        <label style="width: 100px;">{{ 'Address 2' | translate }}</label>
        <input type="text" name="contactadd2"  style="width: 750px;" [(ngModel)]="conaddress2" >
      </div>
      <div class="appointment-form-field">
        <label style="width: 100px;">{{ 'Telephone 1' | translate }}</label>
        <input type="text" name="tel1"  style="width: 150px;" [(ngModel)]="contel1" >
        <label style="width: 50px;"></label>
        <label style="width: 100px;">{{ 'Telephone 2' | translate }}</label>
        <input type="text" name="tel2"  style="width: 150px;" [(ngModel)]="contel2" >
        <label style="width: 50px;"></label>
        <label style="width: 100px;">{{ 'Telephone 3' | translate }}</label>
        <input type="text" name="tel3"  style="width: 150px;" [(ngModel)]="contel3" >
      </div>
      <div class="appointment-form-field">
        <label style="width: 100px;">{{ 'Mobile' | translate }}</label>
        <input type="text" name="Mobile"  style="width: 150px;" [(ngModel)]="conmobile" >
        <label style="width: 50px;"></label>
        <label style="width: 100px;">{{ 'Fax' | translate }}</label>
        <input type="text" name="fax"  style="width: 150px;" [(ngModel)]="confax" >
      </div>
      <div class="appointment-form-field">
        <label style="width: 100px;">{{ 'email' | translate }}</label>
        <input type="email" name="email"  style="width: 750px;" [(ngModel)]="conemail" >
      </div>
      <div class="appointment-form-field">
        <label style="width: 100px;">{{ 'Website' | translate }}</label>
        <input type="url" name="contactweb"  style="width: 750px;" [(ngModel)]="conweb" >
      </div>
      <BR>
        <table>
          <thead>
              <tr >
                  <th style="width: 30%;"></th>
                  <th style="width: 40%;align-self: center;"></th>
                  <th style="width: 30%;"></th>
              </tr>
          </thead>
          <tbody>

              <tr>
                <td data-column="Item ID"> </td>
                <td data-column="Item Name"> <label style="font-size: large;font-weight: bold;">{{'Photo' | translate}}</label></td>
                <td data-column="Item Name"></td>
            </tr>
              <tr>
                <td data-column="Item ID"> </td>
                <td data-column="Item Name" *ngIf= "!wk_Acc_Not"><img src="assets/images/Person.jpg"  alt="Item Image" width="200px" height="200px" style="border: 1px;border-style: double;"/></td>

                <td data-column="Item Name" *ngIf= "!wk_Acc_Not1"><img src="data:image/jpg;base64,{{myimage}}"  alt="Item Image" width="200px" height="200px" style="border: 1px;border-style: double;"/></td>
                <td data-column="Item Name"><input (change)="picked($event)" type="file" id="photo" name="photo" accept="image/*" style="width: 250px;"></td>
            </tr>

          </tbody>
        </table>

    </form>
  </div>
  </div>
</div>
<BR>
<BR>

  <BR>
  <form style="width: 100%;text-align: center;">
    <label style="width: 25%;"></label>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px; font-weight: bold;" name="submit" (click)="submitContacts()">{{ 'Submit' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="Delete" (click)="MesgDelete()">{{ 'Delete' | translate }}</button>
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="New" (click)="NewData()">{{ 'New' | translate }}</button>
    <a href="Home">
    <button type="button" class="theme-button btn" style="width: 10%;height: 75px;font-weight: bold;" name="Back">{{ 'Home' | translate }}</button>
    </a>
    <label style="width: 25%;"></label>
  </form>
  <BR>
    <BR>

</section>



